import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import MonitoringHarian from "./pages/MonitoringHarian";
import MonitoringJurnalMakan from "./pages/MonitoringJurnalMakan";
import StaffList from "./pages/StaffList";
import StaffCreate from "./pages/StaffCreate";
import IbuList from "./pages/IbuList";
import IbuDetail from "./pages/IbuDetail";
import WeeklyReport from "./pages/WeeklyReport";
import Layout from "./components/Layout";
import PrivateRoute from "./routes/PrivateRoute";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* default */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* public */}
        <Route path="/login" element={<Login />} />

        {/* protected */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* ================= MONITORING ================= */}

        <Route
          path="/monitoring"
          element={
            <PrivateRoute>
              <Layout>
                <MonitoringHarian />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/monitoring/jurnal-makan"
          element={
            <PrivateRoute>
              <Layout>
                <MonitoringJurnalMakan />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* ================= STAFF ================= */}

        <Route
          path="/staff"
          element={
            <PrivateRoute>
              <Layout>
                <StaffList />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/staff/create"
          element={
            <PrivateRoute>
              <Layout>
                <StaffCreate />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* ================= IBU ================= */}

        <Route
          path="/ibu"
          element={
            <PrivateRoute>
              <Layout>
                <IbuList />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/ibu/:id"
          element={
            <PrivateRoute>
              <Layout>
                <IbuDetail />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* ================= REPORT ================= */}

        <Route
          path="/reports/weekly"
          element={
            <PrivateRoute>
              <Layout>
                <WeeklyReport />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* fallback */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
